import { useEffect, useMemo, useRef, useState } from "react";
import "./index.css";
import { clsx } from "clsx";
import type { ITextareaProps } from "./types";

export const Textarea = (props: ITextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [length, setLength] = useState<number>(0);

  const nativeProps: ITextareaProps = useMemo(() => {
    const nativeProps: ITextareaProps = { ...props };
    delete nativeProps.invalid;
    delete nativeProps.autosize;
    delete nativeProps.color;

    return nativeProps;
  }, [props]);

  const rootClass: string = clsx(
    "nuco-textarea",
    `nuco-textarea--${props.color || "layer1"}`,
    props.disabled && "nuco-textarea--disabled",
    props.readOnly && "nuco-textarea--readOnly",
    props.invalid && "nuco-textarea--invalid",
    props.autosize && "nuco-textarea--autosize",
    props.className,
  );

  useEffect(() => {
    if (props.autosize && textareaRef.current) {
      const element = textareaRef.current;
      element.style.height = "auto";

      const computed = window.getComputedStyle(element);
      const borderTop = parseFloat(computed.borderTopWidth);
      const borderBottom = parseFloat(computed.borderBottomWidth);

      element.style.height =
        element.scrollHeight + borderTop + borderBottom + "px";
    }
  }, [props.autosize, props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    if (props.maxLength !== undefined) {
      setLength(e.currentTarget.value.length);
    }

    if (props.onChange) {
      props.onChange(e.currentTarget.value, e);
    }
  };

  return (
    <div className={rootClass}>
      <textarea
        {...nativeProps}
        ref={textareaRef}
        className="nuco-textarea__textarea nuco-typography--body"
        onChange={handleChange}
      />
      {props.maxLength && !props.disabled && (
        <div className="nuco-textarea__length nuco-typography--caption">
          {length}/{props.maxLength}
        </div>
      )}
    </div>
  );
};
